<div class="w-30rem">
  <ui-card>
    <div class="w-full flex flex-column gap-3">
      <div class="flex flex-column align-items-center justify-content-center gap-3">
        <img src="assets/Novatellus.svg" alt="Novatellus" class="w-12rem max-w-full h-auto" />

        <!-- Verifica in corso -->
        <ng-container *ngIf="state() === 'verifying'">
          <span class="text-2xl font-bold">Verifica in corso</span>
          <span class="text-sm text-center">Stiamo confermando il tuo indirizzo email.</span>
          <p-skeleton height="2.5rem" width="100%" borderRadius="10px"></p-skeleton>
        </ng-container>

        <!-- Confermata -->
        <ng-container *ngIf="state() === 'confirmed'">
          <span class="text-2xl font-bold">Email confermata</span>
          <span class="text-sm text-center">{{ message() }}</span>
          <span class="text-sm text-center">Accedi per vedere i tuoi acquisti.</span>
        </ng-container>

        <!-- Link non valido o scaduto -->
        <ng-container *ngIf="state() === 'failed'">
          <span class="text-2xl font-bold">Link non valido</span>
          <span class="text-sm text-center">{{ message() }}</span>
        </ng-container>

        <!-- Aperta senza token: non c'è nulla da confermare -->
        <ng-container *ngIf="state() === 'missing-token'">
          <span class="text-2xl font-bold">Link incompleto</span>
          <span class="text-sm text-center">
            Manca il codice di conferma. Apri il link direttamente dall'email che ti abbiamo
            inviato.
          </span>
        </ng-container>
      </div>

      <!-- Email confermata: si prosegue con l'accesso, perché la conferma non
           apre da sola una sessione. L'accesso è quello Keycloak della topbar. -->
      <p-button
        *ngIf="state() === 'confirmed'"
        type="button"
        label="Accedi"
        icon="pi pi-sign-in"
        styleClass="w-full confirm-email__login"
        (onClick)="onKeycloakLogin()"
      ></p-button>

      <!-- Link scaduto o già usato: nuova email di conferma -->
      <form
        *ngIf="state() === 'failed'"
        #resendForm="ngForm"
        (ngSubmit)="onResend(resendForm)"
        class="w-full flex flex-column gap-3"
      >
        <span class="w-full flex flex-column gap-2">
          <label for="resendEmail">Email*</label>
          <input
            id="resendEmail"
            type="email"
            pInputText
            name="resendEmail"
            [(ngModel)]="resendEmail"
            required
            email
            autocomplete="email"
            class="w-full"
          />
        </span>

        <div *ngIf="resendError" class="text-sm text-center" role="alert">{{ resendError }}</div>

        <p-button
          type="submit"
          label="Invia una nuova email di conferma"
          styleClass="w-full"
          [loading]="isSubmitting"
        ></p-button>
      </form>

      <span class="text-center text-sm" *ngIf="state() !== 'verifying'">
        Torna alla vetrina dei piani
        <p-button
          label="Piani"
          [text]="true"
          size="small"
          severity="secondary"
          styleClass="underline p-0"
          (onClick)="goToPlans()"
        />
      </span>
    </div>
  </ui-card>
</div>
